import qs from 'qs';

// RND-8628: a PSP return URL can carry the same key twice - we build success_url with our own
// status=approved and the PSP (BroPay) appends its own status=complete. qs folds repeats into an
// array, so `status === 'approved'` was false on a paid deposit and the trader saw "Something went
// wrong". Keep the FIRST non-empty value: the URL we built always comes before anything the PSP
// appends, and an empty placeholder of ours (epay sends `status=`) yields to the PSP's value (qs's
// `duplicates: 'first'` cannot do that). No return handler reads an array-valued param.
export function parsePspReturnQuery(queryString: string): Record<string, any> {
    const parsed = qs.parse(queryString, { ignoreQueryPrefix: true }) as Record<string, any>;
    Object.keys(parsed).forEach((key) => {
        const value = parsed[key];
        if (Array.isArray(value)) parsed[key] = value.find((v) => v !== '') ?? value[0];
    });
    return parsed;
}
